<form [formGroup]="testForm" (ngSubmit)="submitTest()" class="p-fluid">
  <!--<div class="form-group" *ngIf="isDialogDataReady && !selectedUser">-->
  <!--<div class="form-group" *ngIf="!selectedUser">-->
  <div class="form-group" *ngIf="!testForm.get('userId')?.disabled">
    <p-floatLabel variant="in">
      <p-dropdown
        placeholder="Interessent auswählen"
        [options]="users"
        optionLabel="fullName"
        optionValue="userId"
        formControlName="userId"
        appendTo="body"
        [showClear]="true"
        (onChange)="onUserChanged()"
      >
      </p-dropdown>
      <label for="userName">Interessent</label>
    </p-floatLabel>
  </div>

  <div class="form-group">
    <p-floatLabel>
      <p-dropdown
        [options]="[
          { label: 'Ergebnis senden', value: 'result' },
          { label: 'Einladung senden', value: 'invitation' }
        ]"
        formControlName="testAction"
        placeholder="Aktion auswählen"
        [showClear]="true"
        (onChange)="onActionChanged($event.value)"
      >
      </p-dropdown>
      <label>Test Aktion</label>
    </p-floatLabel>
  </div>

  <div class="form-group">
    <p-floatLabel>
      <div *ngIf="isBrowser">
        <quill-editor
          [modules]="quillModules"
          [formats]="quillFormats"
          (onEditorCreated)="onEditorCreated($event)"
          formControlName="emailText"
          style="height: 300px"
        ></quill-editor>
      </div>
    </p-floatLabel>
  </div>

  <div class="form-buttons">
    <button
      pButton
      aria-label="Speichern"
      label="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!testForm.valid"
    ></button>
    <button
      pButton
      aria-label="Abbrechen"
      label="Abbrechen"
      icon="pi pi-times"
      type="button"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
